module.exports = __webpack_public_path__ + "static/img/JP.862f6933.jpg";